module.exports = __webpack_public_path__ + "img/chat_w.52d79283.svg";